import { Line } from 'vue-chartjs'
import { Component, Vue, Prop } from 'vue-property-decorator'

const Comp = Component as any
@Comp(
  {
    extends: Line
  }
)
export default class SalesYearComponent extends Vue<Line> {
  @Prop(Object)
  chartdata!: object

  @Prop(Object)
  options!: object

  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
